import React from 'react';
import WorkspaceAssignmentsPanel from './WorkspaceAssignmentsPanel';

// Admin-only "Workspace Agents" panel (Admin Dashboard → Workspace Agents tab).
// ONE page: tagging and assigning are the same thing — assignment RULES pin a
// workflow to a workspace, an account's workspaces, or all accounts (auto-
// covering new accounts/workspaces), each with its own schedule and on-demand
// runs. Legacy `new_workspace_workflow` tags render as read-only rows inside
// the same table. All the behavior lives in WorkspaceAssignmentsPanel; this
// shell only provides the embedded-card chrome AdminDashboard mounts.

const s = {
  embedded: { background: 'var(--surface,#fff)', borderRadius: '14px', width: '100%', maxWidth: '980px', border: '1px solid var(--border)', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 22px', borderBottom: '1px solid var(--border)', flexShrink: 0 },
  title: { fontWeight: 700, fontSize: '15px', color: 'var(--text-primary)' },
  body: { padding: '20px 22px', display: 'flex', flexDirection: 'column', gap: '18px' },
};

export default function WorkspaceAgentsManager() {
  return (
    <div style={s.embedded}>
      <div style={s.header}>
        <span style={s.title}>Workspace Agents</span>
      </div>
      <div style={s.body}>
        <WorkspaceAssignmentsPanel />
      </div>
    </div>
  );
}
